import { useGetTagsQuery } from '../../../api/ua-insights'
import { LISTING_PAGE_LIMIT } from '../helpers/listing'
import { useUAInsightsScope } from './useUAInsightsNavigation'

export const useAllTagsListing = (enabled = true) => {
  const { networkId, month, genreFilter } = useUAInsightsScope()
  const { data, isFetching, isError, refetch } = useGetTagsQuery(
    { networkId: networkId ?? undefined, month: month ?? undefined, genreId: genreFilter ?? undefined, limit: LISTING_PAGE_LIMIT },
    { skip: !enabled }
  )
  return { data: data ? { tags: data.tags, total: data.page.total } : undefined, isLoading: isFetching, isError, refetch }
}
